<template>
	<div class="partner-list">
		<AddPartnerForm :refreshPartnerList="getPartners" />
		<h2 class="partner-list__header">Lista partnerów</h2>
		<div v-if="getPartnerStatus === 'error'" class="partner-list__error">
			Nie można załadować listy partnerów.
		</div>
		<div v-if="getPartnerStatus === 'pending'">Ładowanie...</div>
		<div v-if="partners.length === 0">Brak partnerów.</div>
		<div v-if="partners.length > 0" class="partnerdashboard__list-container">
			<ul class="partnerdashboard__list">
				<li class="partnerdashboard__list--header">
					<span
						v-for="header_item in header"
						:key="header_item.field"
						:class="'partnerdashboard__' + header_item.field"
						>{{ header_item.title }}</span
					>
				</li>
				<li class="partnerdashboard__list--item" v-for="partner in partners" :key="partner.id">
					<span class="partnerdashboard__name">{{ partner.name }}</span>
					<span class="partnerdashboard__secret-code">
						{{ partner.secret_code }}
					</span>
					<span class="partnerdashboard__action uppercased-text">
						<button
							class="button partner-list__delete"
							:disabled="deletePartnerStatus === 'pending'"
							@click="deletePartner(partner.id)"
						>
							Usuń
						</button>
					</span>
				</li>
			</ul>
			<div v-if="deletePartnerStatus === 'error'" class="partner-list__error">
				Nie można usunąć partnera, spróbuj jeszcze raz.
			</div>
		</div>
	</div>
</template>

<script>
import * as R from 'ramda';
import AppDataMixin from '@/mixins/app-data';
import {api} from '@/core/services/api';
import AddPartnerForm from './AddPartnerForm';

const header = [
	{
		field: 'name',
		title: 'Imię i nazwisko',
	},
	{
		field: 'secret-code',
		title: 'Kod partnera',
	},
	{
		field: 'action',
		title: 'Akcja',
	},
];

export default {
	name: 'PartnerList',
	components: {AddPartnerForm},
	mixins: [AppDataMixin],
	data() {
		return {
			partners: [],
			getPartnerStatus: 'idle',
			deletePartnerStatus: 'idle',
			header,
		};
	},
	async created() {
		this.getPartners();
	},
	methods: {
		async deletePartner(id) {
			const result = window.prompt('Wpisz "OK" w celu potwierdzenia usunięcia partnera.', '');

			if (result.toLowerCase() !== 'ok') return;

			this.deletePartnerStatus = 'pending';

			try {
				const response = await api.delete(`/deletePartner/${id}`);
				this.deletePartnerStatus = 'success';
				this.getPartners();
			} catch (error) {
				console.error(error);
				this.deletePartnerStatus = 'error';
			}
		},
		async getPartners() {
			this.getPartnerStatus = 'pending';

			try {
				const response = await api.get('/getPartners');
				this.partners = response.data;
				this.getPartnerStatus = 'success';
			} catch (error) {
				console.error(error);
				this.getPartnerStatus = 'error';
			}
		},
	},
};
</script>
